import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcShowMore]'
})
export class ShowMoreDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
